import '../typography/index'
import '../media/index'
import '../badge/index'
import './oct-masthead.scss'

const $_prefix = 'oct-masthead' // eslint-disable-line no-unused-vars

document.addEventListener('DOMContentLoaded', event => { // eslint-disable-line no-unused-vars
  process.env.NODE_ENV === 'development' && console.info('[OCT] Intializing OCTMasthead...')
})
